/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_ProduceInputs */

const en_store_produce = /** @type {(inputs: Store_ProduceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produce`)
};

const de_store_produce = /** @type {(inputs: Store_ProduceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obst & Gemüse`)
};

/**
* | output |
* | --- |
* | "Produce" |
*
* @param {Store_ProduceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_produce = /** @type {((inputs?: Store_ProduceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_ProduceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_produce(inputs)
	return en_store_produce(inputs)
});